<script>
	export let title;
</script>

<h1>{title}</h1>

<style>
	h1 {
		text-align: center;
		padding-top: 10px;
	}
</style>
